exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popContainer[data-v-7ae622ea]{height:fit-content;position:absolute;top:0;z-index:2}", ""]);

// exports
